import React, { Component } from "react";
import NumberFormat from "react-number-format";
import Time from "react-time-format";
import { connect } from "react-redux";
import { change_Lang } from "../../../actions/Helper_action";
import n2wordsEN from "n2words/lib/i18n/AR.mjs";
import "../AllPrint.css";
import { FaMapMarkerAlt, FaPhoneAlt } from "react-icons/fa";
class RentPrintArabic extends Component {
 render() {
  const {
   lang,
   change_Lang,
   rent_invoice_obj,
   index_rentcontrct,
   thirdcolor,
   primary_logo,
   footer_logo,
   user,
   name_arb,
  } = this.props;
  // Kurdish
  let numWords1 =
   rent_invoice_obj.introduction !== undefined &&
   rent_invoice_obj.introduction !== null
    ? n2wordsEN(
       parseFloat(rent_invoice_obj.introduction.toString().replace(/,/g, ""))
      )
    : 0;
  let numWords2 =
   rent_invoice_obj.paymentmonth !== undefined &&
   rent_invoice_obj.paymentmonth !== null
    ? n2wordsEN(
       parseFloat(rent_invoice_obj.paymentmonth.toString().replace(/,/g, ""))
      )
    : 0;
  let numWords3 =
   rent_invoice_obj.feelate !== undefined && rent_invoice_obj.feelate !== null
    ? n2wordsEN(
       parseFloat(rent_invoice_obj.feelate.toString().replace(/,/g, ""))
      )
    : 0;
  let numWords4 =
   rent_invoice_obj.safly !== undefined && rent_invoice_obj.safly !== null
    ? n2wordsEN(parseFloat(rent_invoice_obj.safly.toString().replace(/,/g, "")))
    : 0;
  return (
   <>
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <div className={` ${lang !== "en" ? "fk" : "fkp"}`}>
     <div className="conn">
      <div class="row">
       <div class="col-4">
        <p
         style={{
          fontSize: "22px",
          color: "#000",
          textAlign: "right",
          fontWeight: "bold",
         }}
         class=" text-uppercase"
        >
         &nbsp;&nbsp;{change_Lang("date")} &nbsp;:&nbsp;
         <Time
          value={rent_invoice_obj.createdAt}
          format="YYYY-MM-DD"
          style={{
           fontSize: "22px",
           color: "#000",
           fontWeight: "bold",
          }}
         />
        </p>
       </div>
       <div class="col-4 d-flex justify-content-center">
        <p
         style={{
          fontSize: "27px",
          color: "#000",
          fontWeight: "bolder",
         }}
         class={`d-flex justify-content-center text-uppercase ${
          lang !== "en" ? "fk" : "fkp"
         } `}
        >
         ({change_Lang("Rental contract")})
        </p>
       </div>
       <div class="col-4 text-right">
        <p
         style={{
          fontSize: "22px",
          color: "#000",
          fontWeight: "bold",
         }}
         class=" text-uppercase"
        >
         {change_Lang("contract number")} #&nbsp;
         {index_rentcontrct}&nbsp;
        </p>
       </div>
      </div>
      <div class="row">
       <div class="col-12">
        <div class="form-group row form-inline">
         <label
          style={{
           fontSize: "26px",
           color: "black",
           fontWeight: "bold",
          }}
          class="col-sm-2 col-form-label"
         >
          {change_Lang("First Side")}:
         </label>
         <div class="col-sm-4">
          <label
           class="d-flex justify-content-start"
           style={{ fontWeight: "bold", fontSize: "22px" }}
          >
           {rent_invoice_obj.firstname}
          </label>
         </div>

         {/* shahed */}
         <label
          style={{
           fontSize: "26px",
           color: "black",
           fontWeight: "bold",
          }}
          class="col-sm-2 col-form-label"
         >
          {/* {change_Lang("Witness")}: */}
          {change_Lang("Second Side")}:
         </label>
         <div class="col-sm-4">
          <label
           class="d-flex justify-content-start"
           style={{ fontWeight: "bold", fontSize: "22px" }}
          >
           {/* {rent_invoice_obj.witness1} */}

           {rent_invoice_obj.tenantId && rent_invoice_obj.tenantId.secondname}
          </label>
         </div>
         {/* phone */}
         {/* <label
                    style={{
                      fontSize: "26px",
                      color: "black",
                      fontWeight: "bold",
                    }}
                    class="col-sm-2 col-form-label fkk"
                  >
                    رقم الهاتف:
                  </label>
                  <div class="col-sm-4">
                    <label
                      class="d-flex justify-content-start"
                      style={{ fontWeight: "bold", fontSize: "22px" }}
                    >
                      {rent_invoice_obj.phone1}
                    </label>
                  </div>
                  <label
                    style={{
                      fontSize: "26px",
                      color: "black",
                      fontWeight: "bold",
                    }}
                    class="col-sm-2 col-form-label fkk"
                  >
                    رقم الهاتف:
                  </label>
                  <div class="col-sm-4">
                    <label
                      class="d-flex justify-content-start"
                      style={{ fontWeight: "bold", fontSize: "22px" }}
                    >
                      {rent_invoice_obj.tenantId &&
                        rent_invoice_obj.tenantId.phone2}
                    </label>
                  </div> */}
         <label
          style={{
           fontSize: "26px",
           color: "black",
           fontWeight: "bold",
          }}
          class="col-sm-2 col-form-label"
         >
          {" "}
          {change_Lang("first_rule_place")}:
         </label>
         <br />
         <div class="col-sm-4">
          <label
           class="d-flex justify-content-start"
           style={{ fontWeight: "bold", fontSize: "22px" }}
          >
           {rent_invoice_obj.available_id &&
            rent_invoice_obj.available_id.Place_ku}
          </label>
         </div>
         {/* shahed 2 */}
         <label
          style={{
           fontSize: "26px",
           color: "black",
           fontWeight: "bold",
          }}
          class="col-sm-2 col-form-label"
         >
          {" "}
          {/* {change_Lang("Witness")}: */}
          {change_Lang("Type of property")}:
         </label>
         <div class="col-sm-4">
          <label
           class="d-flex justify-content-start"
           style={{ fontWeight: "bold", fontSize: "22px" }}
          >
           {/* {rent_invoice_obj.witness2} */}
           {change_Lang(
            rent_invoice_obj.available_id &&
             rent_invoice_obj.available_id.Property
           )}
          </label>
         </div>
         {/* Area */}
         <label
          style={{
           fontSize: "26px",
           color: "black",
           fontWeight: "bold",
          }}
          class="col-sm-2 col-form-label"
         >
          {" "}
          {change_Lang("Number of property")}:
         </label>
         <br />
         <div class="col-sm-4">
          <label
           class="d-flex justify-content-start"
           style={{ fontWeight: "bold", fontSize: "22px" }}
          >
           {rent_invoice_obj.available_id &&
            rent_invoice_obj.available_id.NOoFProperty}
          </label>
         </div>
         {/* shahed 2 */}
         <label
          style={{
           fontSize: "26px",
           color: "black",
           fontWeight: "bold",
          }}
          class="col-sm-2 col-form-label"
         >
          {" "}
          {/* {change_Lang("Witness")}: */}
          {change_Lang("Area")}:
         </label>
         <div class="col-sm-4">
          <label
           class="d-flex justify-content-start"
           style={{ fontWeight: "bold", fontSize: "22px" }}
          >
           {/* {rent_invoice_obj.witness2} */}
           {rent_invoice_obj.available_id && rent_invoice_obj.available_id.Area}
           &nbsp;م<sup>2</sup>
          </label>
         </div>
        </div>
        <p
         style={{
          fontSize: "22px",
          color: "#fff",
          fontWeight: "bold",
          borderRadius: "50px 0px 0px 0px",
         }}
         id="liniar"
         class="my-1 d-flex justify-content-center fk"
        >
         {change_Lang("agreement")}
        </p>
       </div>
      </div>
      <div className="row">
       <div className="col-12">
        <table className="table border-0">
         <tbody>
          <tr
           style={{
            fontSize: `${
             lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
            }`,
           }}
           className="border-0"
          >
           <th
            className={`${lang !== "en" ? "fkp" : "fkp"}`}
            scope="row"
            style={{
             color: `${thirdcolor}`,
             borderTop: "none",
            }}
           ></th>
           <td
            style={{
             lineHeight: "1.5",
             wordSpacing: "6px",
             color: "black",
             borderTop: "none",
             fontSize: "24px",
             fontWeight: "bold",
            }}
           >
            بما أن الطرف الثاني بحاجة إلى وحدة سكنية لغرض الإسكان، ولأن الطرف
            الأول صاحب الوحدة وينوي تأجيرها، فإن كلا الطرفين وافقا على التوقيع
            على عقد الإيجار، واتفقا على النقاط والفقرات الآتية:
           </td>
          </tr>
          <tr
           style={{
            fontSize: `${
             lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
            }`,
           }}
           className="border-0"
          >
           <th
            className={`${lang !== "en" ? "fkp" : "fkp"}`}
            scope="row"
            style={{
             color: `${thirdcolor}`,
             borderTop: "none",
            }}
           >
            1-
           </th>
           <td
            style={{
             lineHeight: "1.5",
             wordSpacing: "6px",
             color: "black",
             borderTop: "none",
             fontSize: "24px",
             fontWeight: "bold",
            }}
           >
            إن الطرف الأول موافق على تأجير هذا الملك المعين أعلاه بالرقم إلى
            الطرف الثاني لمدة (
            {Math.floor(Number(rent_invoice_obj.rental) / 12)}) سنة من تأريخ (
            <Time
             value={rent_invoice_obj.startdate}
             format="YYYY-MM-DD"
             style={{
              color: "black",
             }}
            />
            ) إلى (
            <Time
             value={rent_invoice_obj.enddate}
             format="YYYY-MM-DD"
             style={{
              color: "black",
             }}
            />
            ) على أن الطرفين موافقان على مبلغ الإيجار، وهو عبارة عن (
            <NumberFormat
             displayType="text"
             thousandSeparator={true}
             value={rent_invoice_obj.paymentmonth}
             style={{}}
             className="text-center"
             prefix={`${rent_invoice_obj.currency === "dolar" ? "$" : "ID"}`}
            />
            ) ({numWords2}&nbsp;
            {lang === "en" && rent_invoice_obj.currency === "dolar"
             ? "($)"
             : lang === "krd" && rent_invoice_obj.currency === "dolar"
             ? "(دۆلار)"
             : lang === "arb" && rent_invoice_obj.currency === "dolar"
             ? "(دولار)"
             : lang === "en" && rent_invoice_obj.currency !== "dolar"
             ? "(ID)"
             : lang === "krd" && rent_invoice_obj.currency !== "dolar"
             ? "(دینار)"
             : lang === "arb" && rent_invoice_obj.currency !== "dolar"
             ? "(دینار)"
             : ""}
            ) لمدة سنة ({Math.floor(Number(rent_invoice_obj.rental) / 12)}).
           </td>
          </tr>
          <tr
           style={{
            fontSize: `${
             lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
            }`,
           }}
          >
           <th
            className={`${lang !== "en" ? "fkp" : "fkp"}`}
            scope="row"
            style={{
             color: `${thirdcolor}`,
             borderTop: "none",
            }}
           >
            2-
           </th>
           <td
            style={{
             lineHeight: "1.5",
             wordSpacing: "6px",
             color: "black",
             fontSize: "24px",
             borderTop: "none",
             textAlign: "justify",
             fontWeight: "bold",
            }}
           >
            إن مقدمة هذا العقد جزء من هذا العقد ولا ينفصل عنه.
           </td>
          </tr>
          <tr
           style={{
            fontSize: `${
             lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
            }`,
           }}
          >
           <th
            className={`${lang !== "en" ? "fkp" : "fkp"}`}
            scope="row"
            style={{
             color: `${thirdcolor}`,
             borderTop: "none",
            }}
           >
            3-
           </th>
           <td
            style={{
             lineHeight: "1.5",
             wordSpacing: "6px",
             color: "black",

             fontSize: "24px",
             borderTop: "none",
             textAlign: "justify",
             fontWeight: "bold",
            }}
           >
            يدفع الطرف الثاني مبلغ ({" "}
            <NumberFormat
             displayType="text"
             thousandSeparator={true}
             value={rent_invoice_obj.introduction}
             style={{}}
             prefix={`${rent_invoice_obj.currency === "dolar" ? "$" : "ID"}`}
             className="text-center"
            />
            &nbsp;
            {numWords1}
            {lang === "en" && rent_invoice_obj.currency === "dolar"
             ? "($)"
             : lang === "krd" && rent_invoice_obj.currency === "dolar"
             ? "(دۆلار)"
             : lang === "arb" && rent_invoice_obj.currency === "dolar"
             ? "(دولار)"
             : lang === "en" && rent_invoice_obj.currency !== "dolar"
             ? "(ID)"
             : lang === "krd" && rent_invoice_obj.currency !== "dolar"
             ? "(دینار)"
             : lang === "arb" && rent_invoice_obj.currency !== "dolar"
             ? "(دینار)"
             : ""}
            ) إلى الطرف الأول كمقدمة (
            <NumberFormat
             displayType="text"
             thousandSeparator={true}
             value={rent_invoice_obj.Monthintroduction}
             className="text-center"
            />
            ) اشهر، وبعد ذلك، يقوم الطرف الثاني بتسليم مبلغ الإيجار إلى شركة (
            ديڤاين تايم ) مرةً كل (
            <NumberFormat
             displayType="text"
             thousandSeparator={true}
             value={rent_invoice_obj.MonthForRent}
             className="text-center"
            />
            ) أشهر.
           </td>
          </tr>
          <tr
           style={{
            fontSize: `${
             lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
            }`,
           }}
          >
           <th
            className={`${lang !== "en" ? "fkp" : "fkp"}`}
            scope="row"
            style={{
             color: `${thirdcolor}`,
             borderTop: "none",
            }}
           >
            4-
           </th>
           <td
            style={{
             lineHeight: "1.5",
             wordSpacing: "6px",
             color: "black",

             fontSize: "24px",
             borderTop: "none",
             textAlign: "justify",
             fontWeight: "bold",
            }}
           >
            يجب على الطرف الثاني أن يضع مبلغ (
            <NumberFormat
             displayType="text"
             thousandSeparator={true}
             style={{}}
             value={rent_invoice_obj.safly}
             className="text-center"
             prefix={`${rent_invoice_obj.currency === "dolar" ? "$" : "ID"}`}
            />
            &nbsp;
            {numWords4}
            {lang === "en" && rent_invoice_obj.currency === "dolar"
             ? "($)"
             : lang === "krd" && rent_invoice_obj.currency === "dolar"
             ? "(دۆلار)"
             : lang === "arb" && rent_invoice_obj.currency === "dolar"
             ? "(دولار)"
             : lang === "en" && rent_invoice_obj.currency !== "dolar"
             ? "(ID)"
             : lang === "krd" && rent_invoice_obj.currency !== "dolar"
             ? "(دینار)"
             : lang === "arb" && rent_invoice_obj.currency !== "dolar"
             ? "(دینار)"
             : ""}
            ) كتأمينات لدى شركة ( ديڤاين تايم) ، ويردّ هذا المبلغ إلى الطرف
            الثاني بعد تسليم الملك بدون أي نواقص وتصفية جميع الخدمات والكهرباء
            والماء ( الحكومي والخاص بالمشروع) ، وعدم وجود أي خلل ونقص في الملك
            وبنفس شكله ومواصفاته قبل تأجيره.
           </td>
          </tr>
          <tr
           style={{
            fontSize: `${
             lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
            }`,
           }}
          >
           <th
            className={`${lang !== "en" ? "fkp" : "fkp"}`}
            scope="row"
            style={{
             color: `${thirdcolor}`,
             borderTop: "none",
            }}
           >
            5-
           </th>
           <td
            style={{
             lineHeight: "1.5",
             wordSpacing: "6px",
             color: "black",

             fontSize: "24px",
             borderTop: "none",
             textAlign: "justify",
             fontWeight: "bold",
            }}
           >
            إذا أراد المستأجر (الطرف الثاني) فسخ هذا العقد أو إخلاء الملك قبل
            (6) ستة أشهر الأولى قبل انتهاء مدة العقد ، فإن مبلغ التأمينات المشار
            إليه في الفقرة الرابعة لا يرد إليه إلى أن يتم تأجير الملك مرة أخرى
            ويحسب فترة خلوّ الملك ويرد إليه المبلغ المتبقي.
           </td>
          </tr>
          <tr
           style={{
            fontSize: `${
             lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
            }`,
           }}
          >
           <th
            className={`${lang !== "en" ? "fkp" : "fkp"}`}
            scope="row"
            style={{
             color: `${thirdcolor}`,
             borderTop: "none",
            }}
           >
            6-
           </th>
           <td
            style={{
             lineHeight: "1.5",
             wordSpacing: "6px",
             color: "black",

             fontSize: "24px",
             borderTop: "none",
             textAlign: "justify",
             fontWeight: "bold",
            }}
           >
            إذا أراد الطرف الثاني (المستأجر) إخلاء الملك قبل انتهاء مدة العقد
            فإنه يجب إخبار صاحب الملك قبل (1) شهر واحد، وبخلاف هذه المادة فإن
            الإيجار يحسب على الطرف الثاني لهذا العقد (المستأجر) إلى أن يتم تأجير
            العقد مرة أخرى.
           </td>
          </tr>
         </tbody>
        </table>
       </div>
      </div>
     </div>
     <br />
     <br />
     <br />
     <br />
     <br />
     <br />
     <br />
     <br />
     {/* second */}
     <div className="conn">
      <div className="row">
       <div className="col-12">
        <table className="table">
         <tbody>
          <tr
           style={{
            fontSize: `${
             lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
            }`,
           }}
          >
           <th
            className={`${lang !== "en" ? "fkp" : "fkp"}`}
            scope="row"
            style={{
             color: `${thirdcolor}`,
             borderTop: "none",
            }}
           >
            7-
           </th>
           <td
            style={{
             lineHeight: "1.5",
             wordSpacing: "6px",
             color: "black",

             fontSize: "24px",
             borderTop: "none",
             textAlign: "justify",
             fontWeight: "bold",
            }}
           >
            إذا كان الملك مؤثثا، فإنه يجب على الطرفين القيام بجرد الأثاث وتصويره
            وإرفاقه مع العقد للعلم قبل تأجيره.
           </td>
          </tr>
          <tr
           style={{
            fontSize: `${
             lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
            }`,
           }}
          >
           <th
            className={`${lang !== "en" ? "fkp" : "fkp"}`}
            scope="row"
            style={{
             color: `${thirdcolor}`,
             borderTop: "none",
            }}
           >
            8-
           </th>
           <td
            style={{
             lineHeight: "1.5",
             wordSpacing: "6px",
             color: "black",

             fontSize: "24px",
             borderTop: "none",
             textAlign: "justify",
             fontWeight: "bold",
            }}
           >
            إذا كان الملك مؤثثا، فيجب على الطرف الثاني المحافظة على الأثاث وعند
            خروجه يقوم بتسليمه إلى الطرف الأول كما هو، وبخلاف ذلك فإن الطرف
            الثاني مسؤول عن إصلاح الأضرار أو التغيير على ذمته.
           </td>
          </tr>
          <tr
           style={{
            fontSize: `${
             lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
            }`,
           }}
          >
           <th
            className={`${lang !== "en" ? "fk" : "fkp"}`}
            style={{
             color: `${thirdcolor}`,
             fontSize: "22px",
             borderTop: "none",
            }}
            scope="row"
           >
            9-
           </th>
           <td
            style={{
             lineHeight: "1.5",
             wordSpacing: "6px",
             color: "black",

             fontSize: "24px",
             borderTop: "none",
             textAlign: "justify",
             fontWeight: "bold",
            }}
           >
            إذا كانت الوحدة السكنية أو التجارية (مؤثثا) فإن شركة (ديڤاين تايم)
            تقوم بموافقة الطرف الأول والثاني بجرد الأثاث داخل الوحدة مع التصوير
            والأرشفة مع العقد قبل تأجيره.
           </td>
          </tr>
          <tr
           style={{
            fontSize: `${
             lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
            }`,
           }}
          >
           <th
            className={`${lang !== "en" ? "fkp" : "fkp"}`}
            scope="row"
            style={{
             color: `${thirdcolor}`,
             borderTop: "none",
            }}
           >
            10-
           </th>
           <td
            style={{
             lineHeight: "1.3",
             wordSpacing: "4px",
             color: "black",
             fontSize: "24px",
             borderTop: "none",
             textAlign: "justify",
             fontWeight: "bold",
            }}
           >
            على الطرف الأول قبل أن يؤجر ملكه تصفية مبلغ الماء والكهرباء (الحكومي
            والخاص) وتصفية الضريبة إذا وجدت وأي خدمة أخرى و تنظيف الملك يكون في
            ذمته قبل تسليم المفتاح إلى المستأجر.
           </td>
          </tr>
          <tr
           style={{
            fontSize: `${
             lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
            }`,
           }}
          >
           <th
            className={`${lang !== "en" ? "fkp" : "fkp"}`}
            scope="row"
            style={{
             color: `${thirdcolor}`,
             borderTop: "none",
            }}
           >
            11-
           </th>
           <td
            style={{
             lineHeight: "1.3",
             wordSpacing: "4px",
             color: "black",
             fontSize: "24px",
             borderTop: "none",
             textAlign: "justify",
             fontWeight: "bold",
            }}
           >
            أجرة الماء والكهرباء ( الحكومي والخاص بالمشروع) و جميع الخدمات
            الأخرى تكون على ذمة الطرف الثاني في مدة استئجاره ويسلم جميع
            الفاتورات إلى شركة ( ديڤاين تايم) ، وعند انتهاء عقد الإيجار يجب على
            الطرف الثاني أن يبرأ ذمته من أجرة الماء والكهرباء وأي خدمة أخرى.
           </td>
          </tr>
          <tr
           style={{
            fontSize: `${
             lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
            }`,
           }}
          >
           <th
            className={`${lang !== "en" ? "fkp" : "fkp"}`}
            scope="row"
            style={{
             color: `${thirdcolor}`,
             borderTop: "none",
            }}
           >
            12-
           </th>
           <td
            style={{
             lineHeight: "1.3",
             wordSpacing: "4px",
             color: "black",
             borderTop: "none",
             textAlign: "justify",
             fontSize: "24px",
             fontWeight: "bold",
            }}
           >
            على الطرف الثاني استخدام الملك موضوع العقد بالشكل الذي تم العقد عليه
            للتجارة أو الإسكان وبخلاف ذلك يجب على الطرف الثاني أن يدفع مبلغ (
            <NumberFormat
             displayType="text"
             thousandSeparator={true}
             style={{}}
             value={rent_invoice_obj.feelate}
             className="text-center"
             prefix={`${rent_invoice_obj.currency === "dolar" ? "$" : "ID"}`}
            />
            &nbsp;
            {numWords3}
            {lang === "en" && rent_invoice_obj.currency === "dolar"
             ? "($)"
             : lang === "krd" && rent_invoice_obj.currency === "dolar"
             ? "(دۆلار)"
             : lang === "arb" && rent_invoice_obj.currency === "dolar"
             ? "(دولار)"
             : lang === "en" && rent_invoice_obj.currency !== "dolar"
             ? "(ID)"
             : lang === "krd" && rent_invoice_obj.currency !== "dolar"
             ? "(دینار)"
             : lang === "arb" && rent_invoice_obj.currency !== "dolar"
             ? "(دینار)"
             : ""}
            ) كغرامة لكل يوم على المخالفة.
           </td>
          </tr>
          <tr
           style={{
            fontSize: `${
             lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
            }`,
           }}
          >
           <th
            className={`${lang !== "en" ? "fkp" : "fkp"}`}
            scope="row"
            style={{ color: `${thirdcolor}`, borderTop: "none" }}
           >
            13-
           </th>
           <td
            style={{
             lineHeight: "1.3",
             wordSpacing: "4px",
             color: "black",
             fontSize: "24px",
             borderTop: "none",
             textAlign: "justify",
             fontWeight: "bold",
            }}
           >
            لا يجوز للطرف الثاني تأجير الملك كله أو بعضه إلا بموافقة الطرف الأول
            على أن يكون بشكل تحريري، وبخلاف ذلك يعد من ( إيجار من الباطن) ويكون
            سببا في إنهاء العقد ولا يكون للطرف الثاني أي حق تعويضي.
           </td>
          </tr>
          <tr
           style={{
            fontSize: `${
             lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
            }`,
           }}
          >
           <th
            className={`${lang !== "en" ? "fkp" : "fkp"}`}
            scope="row"
            style={{ color: `${thirdcolor}`, borderTop: "none" }}
           >
            14-
           </th>
           <td
            style={{
             lineHeight: "1.3",
             wordSpacing: "4px",
             color: "black",
             borderTop: "none",
             textAlign: "justify",
             fontSize: "24px",
             fontWeight: "bold",
            }}
           >
            لا يجوز للطرف الثاني التصرف في الملك المأجور والأثاث بداخله بأي شكل
            إلا بموافقة الطرف الأول ، وبخلاف ذلك ينفسخ العقد ولا يحق للطرف
            الثاني أن يطلب أي تعويض.
           </td>
          </tr>

          <tr
           style={{
            fontSize: `${
             lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
            }`,
           }}
          >
           <th
            className={`${lang !== "en" ? "fkp" : "fkp"}`}
            scope="row"
            style={{
             color: `${thirdcolor}`,
             borderTop: "none",
            }}
           >
            15-
           </th>
           <td
            style={{
             lineHeight: "1.3",
             wordSpacing: "4px",
             color: "black",
             borderTop: "none",
             textAlign: "justify",
             fontSize: "24px",
             fontWeight: "bold",
            }}
           >
            إن شركتنا ( ديڤاين تايم) ليست مسؤولة عن عدم دفع أجرة الطرف الثاني،
            ولكن يستطيع الطرف الأول مراجعة المحاكم لأخذ حقه من الطرف الثاني،
            وعند اللجوء إلى المحكمة المختصة فإن شركتنا تعطي التوضيحات إلى
            المحكمة عند الضرورة وذلك بعد تبليغها وفق تبليغ رسمي.
           </td>
          </tr>
          <tr
           style={{
            fontSize: `${
             lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
            }`,
           }}
          >
           <th
            className={`${lang !== "en" ? "fkp" : "fkp"}`}
            scope="row"
            style={{
             color: `${thirdcolor}`,
             borderTop: "none",
            }}
           >
            16-
           </th>
           <td
            style={{
             lineHeight: "1.3",
             wordSpacing: "4px",
             color: "black",
             borderTop: "none",
             textAlign: "justify",
             fontSize: "24px",
             fontWeight: "bold",
            }}
           >
            إذا قام الطرف الأول ببيع الملك قبل انتهاء مدة الإيجار فإنه يحق للطرف
            الثاني البقاء في الملك إلى انتهاء مدة العقد، ويلتزم الصاحب الجديد
            بمضمون هذا العقد.
           </td>
          </tr>
         </tbody>
        </table>
       </div>
      </div>
     </div>
     <br />
     <br />
     <br />
     <br />
     <br />
     <br />
     <br />
     <br />
     {/* third table */}
     <div className="conn">
      <div className="row">
       <div className="col-12">
        <table className="table">
         <tbody>
          <tr
           style={{
            fontSize: `${
             lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
            }`,
           }}
          >
           <th
            className={`${lang !== "en" ? "fkp" : "fkp"}`}
            scope="row"
            style={{
             color: `${thirdcolor}`,
             borderTop: "none",
            }}
           >
            17-
           </th>
           <td
            style={{
             lineHeight: "1.3",
             wordSpacing: "4px",
             color: "black",
             borderTop: "none",
             textAlign: "justify",
             fontSize: "24px",
             fontWeight: "bold",
            }}
           >
            يقوم طرفا العقد بدفع مبلغ قدره (%50) من إيجار شهر واحد للشركة كعمولة
            بدلآ مقابل جمع الطرفين معآ وتنظيم العقد.
           </td>
          </tr>
          <tr
           style={{
            fontSize: `${
             lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
            }`,
           }}
          >
           <th
            className={`${lang !== "en" ? "fkp" : "fkp"}`}
            scope="row"
            style={{ color: `${thirdcolor}`, borderTop: "none" }}
           >
            18-
           </th>
           <td
            style={{
             lineHeight: "1.3",
             wordSpacing: "4px",
             color: "black",
             borderTop: "none",
             textAlign: "justify",
             fontSize: "24px",
             fontWeight: "bold",
            }}
           >
            إذا لم يتمكن الطرف الثاني من الحصول على إجازة الجهة المعنية إلى
            تأريخ (
            <Time
             value={rent_invoice_obj.duedate}
             format="YYYY-MM-DD"
             style={{
              fontSize: "22px",
              color: "#000",
              fontWeight: "bold",
             }}
            />
            )، فإن العقد ينفسخ مباشرة ويأخذ الطرف الثاني المبلغ.
           </td>
          </tr>
          <tr
           style={{
            fontSize: `${
             lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
            }`,
           }}
          >
           <th
            className={`${lang !== "en" ? "fkp" : "fkp"}`}
            scope="row"
            style={{ color: `${thirdcolor}`, borderTop: "none" }}
           >
            19-
           </th>
           <td
            style={{
             lineHeight: "1.3",
             wordSpacing: "4px",
             color: "black",
             borderTop: "none",
             textAlign: "justify",
             fontSize: "24px",
             fontWeight: "bold",
            }}
           >
            لا يحق للطرف الثاني أن يطلب مفتاح الملك لأى غرض مالم يحصل على إجازة
            الجهة المعنية أو الأمن وقد أشير إليه في الفقرة أعلاها ووجود الختم
            الرسمي على العقد.
           </td>
          </tr>
          <tr
           style={{
            fontSize: `${
             lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
            }`,
           }}
          >
           <th
            className={`${lang !== "en" ? "fkp" : "fkp"}`}
            scope="row"
            style={{ color: `${thirdcolor}`, borderTop: "none" }}
           >
            20-
           </th>
           <td
            style={{
             lineHeight: "1.3",
             wordSpacing: "4px",
             color: "black",
             borderTop: "none",
             textAlign: "justify",
             fontSize: "24px",
             fontWeight: "bold",
            }}
           >
            يلتزم الطرف الثاني بدفع الأجرة كل مرة كاملا ( 7) أيام قبل التاريخ
            المحدد، وإذا تأخر (7) أيام عن التاريخ المحدد فإن الطرف الثاني يكون
            مسؤولا أمام القانون وفق المادة (17) فقرة ( 1) من قانون الإيجار
            العراقي رقم (87) سنة (1979).
           </td>
          </tr>
          <tr
           style={{
            fontSize: `${
             lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
            }`,
           }}
          >
           <th
            className={`${lang !== "en" ? "fkp" : "fkp"}`}
            scope="row"
            style={{ color: `${thirdcolor}`, borderTop: "none" }}
           >
            21-
           </th>
           <td
            style={{
             lineHeight: "1.3",
             wordSpacing: "4px",
             color: "black",
             borderTop: "none",
             textAlign: "justify",
             fontSize: "24px",
             fontWeight: "bold",
            }}
           >
            بعد انتهاء مدة العقد فإن الطرف الثاني يجب أن يلتزم بإخلاء الملك أو
            تجديد العقد وبخلاف ذلك فإن الطرف الثاني يلتزم أن يدفع يوميا مبلغ (
            <NumberFormat
             displayType="text"
             thousandSeparator={true}
             style={{}}
             value={rent_invoice_obj.feelate}
             className="text-center"
             prefix={`${rent_invoice_obj.currency === "dolar" ? "$" : "ID"}`}
            />
            &nbsp;
            {numWords3}
            {lang === "en" && rent_invoice_obj.currency === "dolar"
             ? "($)"
             : lang === "krd" && rent_invoice_obj.currency === "dolar"
             ? "(دۆلار)"
             : lang === "arb" && rent_invoice_obj.currency === "dolar"
             ? "(دولار)"
             : lang === "en" && rent_invoice_obj.currency !== "dolar"
             ? "(ID)"
             : lang === "krd" && rent_invoice_obj.currency !== "dolar"
             ? "(دینار)"
             : lang === "arb" && rent_invoice_obj.currency !== "dolar"
             ? "(دینار)"
             : ""}
            ) دولار كغرامة إلى حين الوصول إلى اتفاق أو إلى حين إخلاء الملك.
           </td>
          </tr>
          <tr
           style={{
            fontSize: `${
             lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
            }`,
           }}
          >
           <th
            className={`${lang !== "en" ? "fkp" : "fkp"}`}
            scope="row"
            style={{ color: `${thirdcolor}`, borderTop: "none" }}
           >
            22-
           </th>
           <td
            style={{
             lineHeight: "1.3",
             wordSpacing: "4px",
             color: "black",
             borderTop: "none",
             textAlign: "justify",
             fontSize: "24px",
             fontWeight: "bold",
            }}
           >
            يلتزم الطرفان بتنفيذ جميع المعاملات المالية من دفع وأخذ الأجرة عن
            طريق شركة (ديڤاين تايم).
           </td>
          </tr>
          <tr
           style={{
            fontSize: `${
             lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
            }`,
           }}
          >
           <th
            className={`${lang !== "en" ? "fkp" : "fkp"}`}
            scope="row"
            style={{ color: `${thirdcolor}`, borderTop: "none" }}
           >
            23-
           </th>
           <td
            style={{
             lineHeight: "1.6",
             wordSpacing: "4px",
             color: "black",
             borderTop: "none",
             textAlign: "justify",
             fontSize: "24px",
             fontWeight: "bold",
            }}
           >
            بعد إنتهاء مدة العقد، إذا وافق الطرفان على تجديد العقد بالسعر
            اليومي، ستتقوم شركة (ديڤاين تايم) بإبرام عقد جديد لهما، ويقوم طرفا
            العقد بدفع مبلغ قدره (%50) من إيجار شهر واحد للشركة مقابل الخدمات
            المذكورة التالية التي تقدمها الشركة.
            <br />
            1- المساعدة وإدارة جميع الأمور الإدارية.
            <br />
            2- الإتصال بالمستأجر وإبلاغه عند إقتراب موعد إستلام الإيجار.
            <br />
            3- إستلام العقار وتسليمه لصاحب العقار.
            <br />
            4- مساعدة المستأجر وصاحب العقار في حل أي مشاكل وأضرار قد تلحق
            بالعقار.
            <br />
            5- إذا كان صاحب العقار خارج إقليم كوردستان، فيجب إرسال أمواله عن
            طريق البنك وبالعكس.
           </td>
          </tr>
          <tr
           style={{
            fontSize: `${
             lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
            }`,
           }}
          >
           <th
            className={`${lang !== "en" ? "fkp" : "fkp"}`}
            scope="row"
            style={{ color: `${thirdcolor}`, borderTop: "none" }}
           >
            24-
           </th>
           <td
            style={{
             lineHeight: "1.3",
             wordSpacing: "4px",
             color: "black",
             borderTop: "none",
             textAlign: "justify",
             fontSize: "24px",
             fontWeight: "bold",
            }}
           >
            عند وجود أي خلاف من الناحية اللغوية، أو التفاصيل بين لغة العقود فإن
            عقد اللغة الكردية يكون المصدر ويُعتمد عليه، وليس العربي أو
            الانجليزي.
           </td>
          </tr>
          <tr
           style={{
            fontSize: `${
             lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
            }`,
           }}
          >
           <th
            className={`${lang !== "en" ? "fkp" : "fkp"}`}
            scope="row"
            style={{ color: `${thirdcolor}`, borderTop: "none" }}
           >
            25-
           </th>
           <td
            style={{
             lineHeight: "1.3",
             wordSpacing: "4px",
             color: "black",
             borderTop: "none",
             textAlign: "justify",
             fontSize: "24px",
             fontWeight: "bold",
            }}
           >
            عند انتهاء العقد لا يحق للطرف الثاني أن يطلب إرجاع تكلفة التغييرات
            بأي شكل من الطرف الأول بعد خروجه من الملك.
           </td>
          </tr>
         </tbody>
        </table>
       </div>
      </div>
     </div>
     <br />
     <br />
     <br />
     <br />
     <br />
     <br />
     <br />
     <br />
     {/* table fourth */}
     <div className="row">
      <div className="col-12">
       <table className="table">
        <tbody>
         <tr
          style={{
           fontSize: `${
            lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
           }`,
          }}
         >
          <th
           className={`${lang !== "en" ? "fkp" : "fkp"}`}
           scope="row"
           style={{ color: `${thirdcolor}`, borderTop: "none" }}
          >
           26-
          </th>
          <td
           style={{
            lineHeight: "1.3",
            wordSpacing: "4px",
            color: "black",
            borderTop: "none",
            textAlign: "justify",
            fontSize: "24px",
            fontWeight: "bold",
           }}
          >
           إن شركة (ديڤاين تايم) ليست مسؤولة عن أي كارثة طبيعية أو حدوث أي حريق
           أو أي حادثة غير متوقعة.
          </td>
         </tr>
         <tr
          style={{
           fontSize: `${
            lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
           }`,
          }}
         >
          <th
           className={`${lang !== "en" ? "fkp" : "fkp"}`}
           scope="row"
           style={{ color: `${thirdcolor}`, borderTop: "none" }}
          >
           27-
          </th>
          <td
           style={{
            lineHeight: "1.3",
            wordSpacing: "4px",
            color: "black",
            borderTop: "none",
            textAlign: "justify",
            fontSize: "24px",
            fontWeight: "bold",
           }}
          >
           إني كمستأجر سأكون ملتزمآ بدفع الإيجار كما هو مذكور في النقطتين (٢٠)
           العشرون و (٢١) الواحد وعشرون، وإذا لم أكن ملتزمآ قبل إخطاري قانونيآ،
           أوافق على إيقاف خدمات (الماء والكهرباء) من قبل إدارة المشروع.
          </td>
         </tr>
         <tr
          style={{
           fontSize: `${
            lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
           }`,
          }}
         >
          <th
           className={`${lang !== "en" ? "fkp" : "fkp"}`}
           scope="row"
           style={{ color: `${thirdcolor}`, borderTop: "none" }}
          >
           28-
          </th>
          <td
           style={{
            lineHeight: "1.3",
            wordSpacing: "4px",
            color: "black",
            borderTop: "none",
            textAlign: "justify",
            fontSize: "24px",
            fontWeight: "bold",
           }}
          >
           إلتزام صاحب العقار والمستأجر بالقرار الصادر عن حكومة إقليم كوردستان
           بشأن صرف نوع العملة من (دولار) إلى (دينار) حسب سعر اليوم الذي يتم فيه
           إصدار القرار.
          </td>
         </tr>
         <tr
          style={{
           fontSize: `${
            lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
           }`,
          }}
         >
          <th
           className={`${lang !== "en" ? "fkp" : "fkp"}`}
           scope="row"
           style={{ color: `${thirdcolor}`, borderTop: "none" }}
          >
           29-
          </th>
          <td
           style={{
            lineHeight: "1.3",
            wordSpacing: "4px",
            color: "black",
            borderTop: "none",
            textAlign: "justify",
            fontSize: "24px",
            fontWeight: "bold",
           }}
          >
           تكوّن هذا العقد من ( 29 ) تسع وعشرين نقطة و ( 4 ) اربعة صفحات‌ ونلتزم
           بجميع الفقرات والنقاط وهي جزء من العقد.{" "}
          </td>
         </tr>
        </tbody>
       </table>
      </div>
     </div>
     <div className="form-inline">
      <p
       className="d-flex justify-content-start"
       style={{
        fontSize: "18px",
        color: "black",
        textAlign: "justify",
        fontWeight: "bold",
       }}
      >
       {change_Lang("note")}&nbsp;:{rent_invoice_obj.note}
      </p>
     </div>
     <br /> <br /> <br /> <br />
     <br />
     <br />
     <br />
     <div className="row">
      <div className="form-group d-flex justify-content-center col-4">
       <label
        style={{
         fontSize: "22px",
         color: "#000",
         fontWeight: "bold",
        }}
        className="form-label"
       >
        الجانب الأول (مالك العقار)
       </label>
      </div>
      <div className="col-4">
       <div className="form-group d-flex justify-content-center">
        <label
         style={{
          fontSize: "22px",
          color: "#000",
          fontWeight: "bold",
         }}
         className="form-label"
        >
         {change_Lang("Contract Organizer")}
        </label>
       </div>
      </div>
      <div className="col-4 d-flex justify-content-center">
       <div className="form-group ">
        <label
         style={{
          fontSize: "22px",
          color: "#000",
          fontWeight: "bold",
         }}
         className="form-label"
        >
         الجانب الثاني (المستأجر)
        </label>
       </div>
      </div>
     </div>
     <div className="row">
      <div className="col-4 form-group d-flex justify-content-center">
       <label
        style={{
         fontSize: "22px",
         color: "#000",
         fontWeight: "bold",
        }}
        className="form-label"
       >
        {rent_invoice_obj.firstname}
       </label>
      </div>
      <div className="col-4">
       <div className="form-group d-flex justify-content-center">
        <label
         style={{
          fontSize: "22px",
          color: "#000",
          fontWeight: "bold",
         }}
         className="form-label"
        >
         {`${rent_invoice_obj.agentId && rent_invoice_obj.agentId.fname} ${
          rent_invoice_obj.agentId && rent_invoice_obj.agentId.lname
         }`}
        </label>
       </div>
      </div>
      <div className="col-4 d-flex justify-content-center">
       <div className="form-group ">
        <label
         style={{
          fontSize: "22px",
          color: "#000",
          fontWeight: "bold",
         }}
         className="form-label"
        >
         {rent_invoice_obj.tenantId && rent_invoice_obj.tenantId.secondname}
        </label>
       </div>
      </div>
     </div>
    </div>
   </>
  );
 }
}

const mapStateToProps = (state) => {
 return {
  lang: state.HelperReducer.lang,
  rent_invoice_obj: state.Invoice_Reducer.rent_invoice_obj,
  index_rentcontrct: state.Invoice_Reducer.index_rentcontrct,
  user: state.AuthReducer.user,
  primarycolor: state.HelperReducer.primarycolor,
  secondarycolor: state.HelperReducer.secondarycolor,
  thirdcolor: state.HelperReducer.thirdcolor,
  primary_logo: state.HelperReducer.primary_logo,
  footer_logo: state.HelperReducer.footer_logo,
  name_arb: state.HelperReducer.name_arb,
 };
};

const mapDispatchToProps = (dispatch) => {
 return {
  change_Lang: (key) => dispatch(change_Lang(key)),
 };
};

export default connect(mapStateToProps, mapDispatchToProps)(RentPrintArabic);
